import API from "./commons/Api.js";
import { eventBus, EVENTS } from './commons/EventBus.js';
import router from "./commons/Router.js";
import "./libs/dropzone.min.js";
import getCoficeFiscale from './libs/calcoloCF/validazioneCodice.js';
import Utils from "./commons/utils.js";

let dropzone;
let dropzone1;
let dropzoneVideo;
let formData = new FormData();
var currentFile = null;
let autocomplete;
let autocomplete1;
let address;
let addressBar;
let renderedData;

eventBus.on(EVENTS.PAGE_AFTER_RENDERING, function (data) {
  const template = data.template;
  if (template != 'form_horeca' || data.refresh) {
    return;
  }
  if(location.href.split('/').reverse()[0]!='rds-bar-of-the-week'){
    window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week");
  }
  $(':root').css('--paginatore_horeca', 0);
  renderedData=Object. assign({},data)  ;
  renderedData.refresh=true;

    /*try{
          /!* Gestione Campi SEO *!/
            data.content.seo_title = "RDS Bar Of The Week, gioca in diretta con il tuo bar";
            // cambio il tag 'meta name='description''
            data.content.seo_description='Partecipa al grande torneo a premi tra bar di tutta Italia. Vai in diretta TV. In palio fantastici premi.';

            $(document).attr("title", data.content.seo_title);
            $('meta[name=description]').attr('content',data.content.seo_description);
            /!*$("meta[name=description]").remove();
            $("head").append( "<meta name='description' content=''+data.content.seo_description+''>");*!/

    }catch(e){
            $(document).attr("title", "RDS Bar Of The Week, gioca in diretta con il tuo bar");
        }*/

  const dropzoneOptionsImg = {
    maxFilesize: 6,
    url: "/file/post",
    acceptedFiles: 'image/*',
    autoProcessQueue: false,
    paramName: "fileImg",
    dictDefaultMessage: "Trascina o carica la tua immagine",
    dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    dictInvalidFileType: "You can't upload files of this type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictUploadCanceled: "Upload canceled.",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remove file",
    maxFiles: 1,
    init: function () {
      const vm = this;
      vm.on("addedfile", file => {
        formData.append(vm.element.id, file);
        $("#" + vm.element.id + "_check").val(1);
      });
      vm.on("maxfilesexceeded", function (file) {
        this.removeAllFiles();
        this.addFile(file);
      });
      vm.on("error", function (file, message) {
        $("#" + vm.element.id + "_check").val(0);
      });
    },
  };

  const dropzoneOptionsVideo = {
    maxFilesize: 20,
    url: "/file/post",
    autoProcessQueue: false,
    paramName: "fileVideo",
    dictDefaultMessage: "Trascina o carica il tuo video",
    dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    dictInvalidFileType: "You can't upload files of this type.",
    dictResponseError: "Server responded with {{statusCode}} code.",
    dictCancelUpload: "Cancel upload",
    dictUploadCanceled: "Upload canceled.",
    dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    dictRemoveFile: "Remove file",
    init: function () {
      const vm = this;
      vm.on("addedfile", file => {
        formData.append(vm.element.id, file);
      });
    }
  };

  Dropzone.autoDiscover = false;
  $('div#dropzone-immagine1').addClass('dropzone');
  $('div#dropzone-immagine2').addClass('dropzone');
  dropzone = new Dropzone("div#dropzone-immagine1", dropzoneOptionsImg);
  dropzone1 = new Dropzone("div#dropzone-immagine2", dropzoneOptionsImg);
  // dropzoneVideo = new Dropzone("div#dropzone-video", dropzoneOptionsVideo);







  $(".step_scherzo_button").on({
    click: function () {
      var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_horeca');
      if (num_page == "0") {

        window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week/first_step");
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkFirstBlock(num_page);
      } else if (num_page == "1") {

        window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week/second_step");
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkSecondBlock(num_page);
      } else if (num_page == "2") {

        window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week/third_step");
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkThirdBlock(num_page);
      } else if (num_page == "3") {

        window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week/fourth_step");
        eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
        checkFourthBlock();
      }
      $("html, body").animate({ scrollTop: 0 }, 500);
    }
  });


  function checkMailAlreadyUsed(mailToCheck, fieldName)  {
    return new Promise((resolve, reject)=>{
      if($("#email_giocatore_input").val()==$("#email_input").val())
      {
        $("#email_giocatore_input").parents(".fieldset-gray").addClass("fieldset-error");
        $('#error-message-email_giocatore_input').text("La mail del sostituto non può essere uguale a quella del proprietario");
        resolve(true);
        return
      }
      else
      {
        $("#email_giocatore_input").parents(".fieldset-gray").removeClass("fieldset-error");
        $('#error-message-email_giocatore_input').text("");
      }
      let formMail=new FormData();
      formMail.append('mail', mailToCheck);
      API.postFormData("site/checkMailAlreadyUsed", formMail, function (resp) {
        if (resp.conteggio[0]['conteggio'] >0) {
          $("#" + fieldName).parents(".fieldset-gray").addClass("fieldset-error");
          $('#error-message-'+ fieldName).text("Mail non utilizzabile, usane un'altra");
          resolve(true);
          return
        } else {
          //$("#" + fieldName).parents(".fieldset-gray").removeClass("fieldset-error");
          $('#error-message-'+ fieldName).text("");
          resolve(false);
          return
        }
      }, function () {
        reject();
      });
    });


  }



  function checkLoggedFirstBlock(num_page) {
    /*
        if (user.checkUser()) {
            checkFirstBlock(num_page);
        } else {
            user.popUpRichiediScherzo();
        }
        */
  }

  function fillUserField(u) {
    $('#nome_input').val(u.nome);
    $('#cognome_input').val(u.cognome);
    $('#email_input').val(u.email);
    $('#data_nascita_input').val(u.nascita);
    $('#sesso_input').val(u.genere);
    $('#nome_scherzo').text(u.genere);
    $('#telefono_input').val(u.telefono);
  }


  function checkCap(cap) {
    if (!isNaN(cap) && cap.length == 5)
      return true;
    return false;
  }



  function checkFirstBlock(num_page) {

    let in_error = false;
    if (!in_error) {
      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      const _user = user.getLocalUser();
      if (_user) {
        fillUserField(_user);
      }
      const address1Field = $('#add_input')[0];
      const address2Field = $('#add_bar_input')[0];
      autocomplete = new google.maps.places.Autocomplete(address1Field, {
        // componentRestrictions: { country: ["us", "ca"] },
        fields: ["address_components"],
        types: ["address"],
      });
      autocomplete1 = new google.maps.places.Autocomplete(address2Field, {
        // componentRestrictions: { country: ["us", "ca"] },
        fields: ["address_components"],
        types: ["address"],
      });
      // address1Field.focus();
      // autocomplete.addListener("place_changed", fillInAddress("citta_input","cap_input","provincia_input" ));
      google.maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();
        fillInAddress("citta_input", "cap_input", "provincia_input", 'civico_input', place, "add_input");
      });
      google.maps.event.addListener(autocomplete1, 'place_changed', function () {
        var place = autocomplete1.getPlace();
        fillInAddress("citta_bar_input", "cap_bar_input", "provincia_bar_input", 'civico_bar_input', place, "add_bar_input");
      });
      /* autocomplete1.addListener("place_changed", fillInAddress("citta_bar_input","cap_bar_input","provincia_bar_input", autocomplete1 ));*/

      // $(".error-messages").html("");
      // $("fieldset").removeClass("fieldset-error");
    }
  }

  function fillInAddress(citta, cap, provincia, civico, place, callInd) {
    /*  debugger
      const place = autocomplete.getPlace();
      if(!place)
        return;*/
    console.log(place);
    if (!place.address_components || place.address_components.map(i => i.types[0]).indexOf('route') == -1) {
      $("#" + callInd).parents(".fieldset-gray").addClass("fieldset-error");
      $('#error-message-indirizzo_input').text('Seleziona un indirizzo valido dal menu a tendina');
      return;
    }
    if (place.address_components.map(i => i.types[0]).indexOf('route') == -1) {
      $("#" + callInd).parents(".fieldset-gray").addClass("fieldset-error");
      $('#error-message-indirizzo_input').text('Inserisci il nome della strada');
      return;
    }
    /*if (place.address_components.map(i => i.types[0]).indexOf('street_number') == -1) {
      $("#" + callInd).parents(".fieldset-container").find('.fieldset-civico').fadeIn();
      $("#" + callInd).parents(".fieldset-container").find('.fieldset-civico').width('100px');
      // $("#" + callInd).parents(".fieldset-gray").addClass("fieldset-error");
      // $('#error-message-indirizzo_input').text('Inserisci il numero civico');
    }*/
    else {
      $("#" + callInd).parents(".fieldset-gray").removeClass("fieldset-error");
      $('#error-message-indirizzo_input').text('');
    }
    if(callInd=='add_input'){
      address = place.address_components.find(i => i.types[0] == 'route').long_name;
    }
    if(callInd=='add_bar_input'){
      addressBar = place.address_components.find(i => i.types[0] == 'route').long_name;
    }

    let locality;
    try {
      locality = place.address_components.find(i => i.types[0] == 'locality').long_name;
    } catch (error) {
      locality = place.address_components.find(i => i.types[0] == 'administrative_area_level_3').long_name;
    }

    let postcode="";
    try {
          postcode = place.address_components.find(i => i.types[0] == 'postal_code').long_name;
    }
    catch(e){
        console.warn(e);
    }
    let prov='';
    try {
      prov = place.address_components.find(i => i.types[0] == 'administrative_area_level_2').short_name;
    }catch (e) {
      console.warn(e);
    }


    let streetNumber;
    try {
      streetNumber=place.address_components.map(i => i.types[0]).indexOf('street_number').long_name;
      $("#" + civico).val(streetNumber);
    } catch (error) {

    }


    $("#" + citta).val(locality);
    $("#" + cap).val(postcode);
    $("#" + provincia).val(prov);


    // for (const component of place.address_components) {
    //   const componentType = component.types[0];
    //   switch (componentType) {
    //     /*case "street_number": {
    //       address1 = `${component.long_name} ${address1}`;
    //       break;
    //     }*/
    //     // case "route": {
    //     //   address1 += component.short_name;
    //     //   break;
    //     // }
    //     case "postal_code": {
    //       //postcode = `${component.long_name}${postcode}`;
    //       $("#"+cap).val(component.long_name);
    //       break;
    //     }
    //     /*case "postal_code_suffix": {
    //       postcode = `${postcode}-${component.long_name}`;
    //       break;
    //     }*/
    //     case "locality":
    //       /*document.querySelector("#locality").value*/
    //       $("#"+citta).val(component.long_name);
    //       break;
    //     case "administrative_area_level_2": {
    //       //document.querySelector("#state").value = component.short_name;
    //       $("#"+provincia).val(component.short_name);
    //       break;
    //     }
    //     /*case "country":
    //       document.querySelector("#country").value = component.long_name;
    //       break;*/
    //   }
    // }
  }

  function isMaggiorenne(data_nascita) {
    var oggi = new Date();
    var anni = oggi.getFullYear() - data_nascita.getFullYear();
    var m = oggi.getMonth() - data_nascita.getMonth();
    if (m < 0 || (m === 0 && oggi.getDate() < data_nascita.getDate())) {
      anni--;
    }
    if (anni >= 18)
      return true
    return false;
  }

  async function checkSecondBlock(num_page) {

    let in_error = false;

    $("#email_giocatore_input").parents(".fieldset-gray").removeClass("fieldset-error");
    $("#email_input").parents(".fieldset-gray").removeClass("fieldset-error");
    $('#error-message-email_giocatore_input').text("");
    $('#error-message-email_input').text("");

    $(".obbligatorio_horeca").each(function (index) {
      if (this.value == "") {
        // $(this).next(".icon-error").show();
        $(this).parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else {
        // $(this).next(".icon-error").hide();
        $(this).parents(".fieldset-gray").removeClass("fieldset-error");
      }
    });

    // TO DO - validazione indirizzo
    if ($('#citta_input').val() == "") {
      $('#error-message-indirizzo_input').text('Seleziona un indirizzo valido dal menu a tendina');
      $("#add_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    } else {
      $("#add_input").parents(".fieldset-gray").removeClass("fieldset-error");
    }


    /*  if (!checkCap($("#cap_input").val())) {
        $("#cap_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      }*/


    if (!isMaggiorenne(new Date($("#data_nascita_input").val()))) {
      $("#data_nascita_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    } else
      $("#data_nascita_input").parents(".fieldset-gray").removeClass("fieldset-error");


    if (!validateMail($("#email_input").val()))
    {
        $("#email_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
    } else {
            if (await checkMailAlreadyUsed($("#email_input").val(), 'email_input'))
            {
              in_error = true;
            }
    }

    if ($("#sostituto_input").val() == 1) {
      if (!validateMail($("#email_giocatore_input").val())) {
        $("#email_giocatore_input").parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else if (await checkMailAlreadyUsed($("#email_giocatore_input").val(), 'email_giocatore_input'))
        in_error = true;
    }

    if (!in_error) {
      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      $("#error_informativa").hide();
      $(".error-messages").html("");
      $("fieldset").removeClass("fieldset-error");
    } else
      return;

  }

  function callGetCodiceFiscale() {
    const nome = jQuery('#nome_input').val();
    const cognome = jQuery('#cognome_input').val();
    const dataNascita = jQuery('#data_nascita_input').val();
    const genere = jQuery('#sesso_input').val();
    const luogoNascita = jQuery('#nascita_input').val();
    const cfInput = jQuery('#cf_input').val();
    const cfCal = getCoficeFiscale(nome, cognome, dataNascita, luogoNascita, genere);
    jQuery('#cf_input').val(cfCal);
  }

  function validateMail(mail) {
    let validRegex = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
    if (mail.match(validRegex))
      return 1;
    return 0;
  }

  function checkThirdBlock(num_page) {

    let in_error = false;

    $(".obbligatorio_bar").each(function (index) {
      if (this.value == "") {
        // $(this).next(".icon-error").show();
        $(this).parents(".fieldset-gray").addClass("fieldset-error");
        in_error = true;
      } else {
        // $(this).next(".icon-error").hide();
        $(this).parents(".fieldset-gray").removeClass("fieldset-error");
      }
    });


    // TO DO - validazione indirizzo
    if($('#citta_bar_input').val()==""){
      $('#error-message-indirizzo_bar_input').text('Seleziona un indirizzo valido dal menu a tendina');
      $("#add_bar_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    }
    else
    {
      $("#add_bar_input").parents(".fieldset-gray").removeClass("fieldset-error");
    }

  /*  if (!checkCap($("#cap_bar_input").val())) {
      $("#cap_bar_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    }*/

    if (!validateMail($("#mail_bar_input").val())) {
      $("#mail_bar_input").parents(".fieldset-gray").addClass("fieldset-error");
      in_error = true;
    }

    $("#dropzone-immagine1").removeClass("fieldset-error");
    $("#dropzone-immagine2").removeClass("fieldset-error");

    if ($("#dropzone-immagine1_check").val() == 0) {
      $("#dropzone-immagine1").addClass("fieldset-error");
      in_error = true;
    }

    if ($("#dropzone-immagine2_check").val() == 0) {
      $("#dropzone-immagine2").addClass("fieldset-error");
      in_error = true;
    }


    if (!in_error) {

      $(".counter_step").removeClass("selected");
      num_page = parseInt(num_page) + 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());
      $("#error_radio-consensi-0").hide();
      $(".error-messages").html("");
      $("fieldset").removeClass("fieldset-error");
    }

  }

  function checkFourthBlock() {
    let in_error = false;
    $(".obbligatorio_check").each(function (index) {
      if (!$(this).is(":checked")) {
        in_error = true;
        $("#error_" + $(this).attr('id')).css("visibility", "");
        $("#error_" + $(this).attr('id')).show();
      } else {
        $("#error_" + $(this).attr('id')).css("visibility", "hidden");
      }
    });

    if (!in_error) {
      Utils.showWaitingLoader();
      inviaCandidatura();
    }
  }

  $(".previous_step").on({
    click: function () {
      $(".counter_step").removeClass("selected");
      var num_page = getComputedStyle(document.documentElement).getPropertyValue('--paginatore_horeca');
      num_page = parseInt(num_page) - 1;
      $(".counter_step[data-idx=" + num_page + "]").addClass("selected");
      $(':root').css('--paginatore_horeca', num_page.toString());

    }
  });


  $("#giocatoreSI").click(function () {
    $("#giocatoreNO").removeClass("selected");
    $("#giocatoreSI").addClass("clickable choose_sub_categoria eventi selected");
    $("#sostituto_input").val("0");
    updateFieldGiocatore(0);
  });

  $("#giocatoreNO").click(function () {
    $("#giocatoreSI").removeClass("selected");
    $("#giocatoreNO").addClass("clickable choose_sub_categoria eventi selected");
    $("#sostituto_input").val("1");
    updateFieldGiocatore(1);
  });

  $("#tv_dttSI").click(function () {
    $("#tv_dttNO").removeClass("selected");
    $("#tv_dttSI").addClass("clickable choose_sub_categoria eventi selected");
    $("#tv_dtt_input").val("0");
  });

  $("#tv_dttNO").click(function () {
    $("#tv_dttSI").removeClass("selected");
    $("#tv_dttNO").addClass("clickable choose_sub_categoria eventi selected");
    $("#tv_dtt_input").val("1");
  });

  function updateFieldGiocatore(isGiocatore) {

    if (isGiocatore) {
      $("#sezioneGiocatore").show();
      $("#nome_giocatore_input").addClass("hidden_input obbligatorio_horeca");
      $("#cognome_giocatore_input").addClass("hidden_input obbligatorio_horeca");
      $("#email_giocatore_input").addClass("hidden_input obbligatorio_horeca");
      $("#telefono_giocatore_input").addClass("hidden_input obbligatorio_horeca");
    } else {
      $("#sezioneGiocatore").hide();
      $("#nome_giocatore_input").val("").removeClass("obbligatorio_horeca");
      $("#cognome_giocatore_input").val("").removeClass("obbligatorio_horeca");
      $("#email_giocatore_input").val("").removeClass("obbligatorio_horeca");
      $("#telefono_giocatore_input").val("").removeClass("obbligatorio_horeca");
    }
  }

  function inviaCandidatura() {

    const data = $("#form_horeca").serializeArray();
    for (const item of data) {
      formData.append(item.name, item.value);
    }
    formData.append('indirizzo', address + ', ' + data.find(i => i.name=='civico_input').value);
    formData.append('indirizzo_bar', addressBar + ', ' + data.find(i => i.name=='civico_bar_input').value);

    API.postFormData("site/invia_candidatura_horeca", formData, function (resp) {
      Utils.hideWaitingLoader();
      if (resp.status == 1) {
        landingHoreca();
      } else {
        alert("Qualcosa è andato storto! Riprovare");
      }
    }, function () {

    });
  }

  function landingHoreca() {
    $(':root').css('--paginatore_horeca', 4);
    window.history.pushState({ page: location.href }, "", "/rds-bar-of-the-week/grazie");
    eventBus.emit(EVENTS.TRACK_PAGE, renderedData);
  }

  window.landingHoreca = landingHoreca;


  /*
  Select Sesso
   */
  $(".scherzo_option").on({
    click: function () {

      $(".scherzo_option").removeClass("scherzo_selected");
      $(this).addClass("scherzo_selected");
      $(".open_drop_scherzo").trigger("click");
      $("#sesso_input").val($(this).text());
      $("#nome_scherzo").text($(this).text());

    }
  });

  $(".open_drop_scherzo").on({
    click: function () {

      $("#option_scherzi_cont").slideToggle();
      $(this).find(".icon_select_scherzo").toggleClass("open");

    }
  });


  /*
  select clienti
   */
  $(".clientela_option").on({
    click: function () {
      $(".clientela_option").removeClass("scherzo_selected");
      $(this).addClass("scherzo_selected");
      $(".open_drop_clientela").trigger("click");
      $("#clientela_input").val($(this).text());
      $("#nome_clientela").text($(this).text());

    }
  });

  $(".open_drop_clientela").on({
    click: function () {
      $("#option_clientela_cont").slideToggle();
      $(this).find(".icon_select_scherzo").toggleClass("open");
    }
  });

  /*
  select bar
   */
  $(".bar_option").on({
    click: function () {

      $(".bar_option").removeClass("scherzo_selected");
      $(this).addClass("scherzo_selected");
      $(".open_drop_bar").trigger("click");
      $("#tipologia_bar_input").val($(this).text());
      $("#nome_bar").text($(this).text());

    }
  });

  $(".open_drop_bar").on({
    click: function () {
      $("#option_bar_cont").slideToggle();
      $(this).find(".icon_select_scherzo").toggleClass("open");
    }
  });

  $(".open_drop_conoscenza").on({
    click: function () {
      $("#option_conoscenza_cont").slideToggle();
      $(this).find(".icon_select_scherzo").toggleClass("open");
    }
  });

  $(".conoscenza_option").on({
    click: function () {

      $(".conoscenza_option").removeClass("scherzo_selected");
      $(this).addClass("scherzo_selected");
      $(".open_drop_conoscenza").trigger("click");
      $("#conoscenza_input").val($(this).text());
      $("#nome_conoscenza").text($(this).text());

    }
  });

  $("#cf_input").on('click focus', function () {
    callGetCodiceFiscale();
  });


  //// Ensuring that only Google Maps adresses are inputted
  function selectFirstAddress(input) {
    google.maps.event.trigger(input, 'keydown', { keyCode: 40 });
    google.maps.event.trigger(input, 'keydown', { keyCode: 13 });
  }

  // Select first address on focusout
  $('input.autocomplete-map-horeca').on('focusout', function () {
    selectFirstAddress(this);
  });

  // Select first address on enter in input
  $('input.autocomplete-map-horeca').on('keydown', function (e) {
    if (e.keyCode == 13) {
      selectFirstAddress(this);
    }
  });


});

